import { render, staticRenderFns } from "./IconSvgConvention.vue?vue&type=template&id=11b30b5c&scoped=true&"
import script from "./IconSvgConvention.vue?vue&type=script&lang=js&"
export * from "./IconSvgConvention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b30b5c",
  null
  
)

export default component.exports